import { Row, Col, Typography, Button, Image, Space } from "antd";
import React from "react";
import { Fade } from "react-awesome-reveal";
import MarketingCard from "~/Components/MarketingCard/MarketingCard";
import MarketPlaceImg from "@assets/KPMG/MarketPlace.png";
import styles from "../InfratechMarketplace.module.scss";
import { Icon } from "@iconify/react";

export const NoData = () => {
  return (
    <div className="projectList">
      <div>
        <Row
          className={styles.backgroundGrad}
          style={{
            paddingTop: "20px",
            paddingBottom: "20px",
            borderRadius: 20,
          }}
        >
          <Col span={24}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 200,
                maxWidth: 600,
                margin: "auto",
                textAlign: "center",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography.Text className="text" style={{ color: "#fff" }}>
                  No data available for your search.
                </Typography.Text>
                <Typography.Text className="text" style={{ color: "#fff" }}>
                  Please consider using a different filter or refining your
                  search criteria.
                </Typography.Text>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
